<template>
        <el-drawer v-model="isShowFileImportDrawer" size="30%" :close-on-click-modal="false" :before-close="fileImportDrawerBeforeClose">
            <template #title>
                    <span class="import-title">{{title}}</span>
            </template>
            <div class="file-select-view">
                <el-descriptions
                    class="margin-top"
                    :column="1"
                    border
                    width="150px"
                >
                    <el-descriptions-item label="模板下载：">
                        <el-button type="text"  @click="getImportTemplate">下载导入模板</el-button>
                    </el-descriptions-item>
                    <el-descriptions-item label="选择文件：">
                        <div v-if="!file">
                            <el-button type="text"  @click="toSelectFile"> 选择文件</el-button>
                            <input type="file" style="display:none" @change="fileChange"
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
                        </div>
                        <div v-else>
                            {{file.name}}<el-button type="text"  @click="toSelectFile" style="margin-left: 20px"> 重新选择</el-button>
                            <input type="file" style="display:none" @change="fileChange"
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="导入预览:" v-if="tableData && tableData.length>0">
                        <el-button type="text" @click="innerPreviewDrawer=true" :disabled="!file">预览</el-button>
                    </el-descriptions-item>
                </el-descriptions>
            </div>
            <div class="file-up-tips">
                <el-result
                    icon="warning"
                    title="提示"
                    sub-title="请按照提示操作！"
                >
                    <template #extra>
                    <div class="tips-cen" v-html="importTips">
                        
                    </div>
                    </template>
                </el-result>
            </div>

          <!-- 预览页面 -->
           <div>
               <el-drawer
                    v-model="innerPreviewDrawer"
                    :append-to-body="true"
                    :size="previewWidth"
                >
                <template #title>
                        <span class="import-title">{{title}}预览</span>
                </template>
                <div class="file-data-preview">
                    <el-table :data="tableData" border height="100%"  header-cell-class-name="hrsys-table-header"> 
                            <el-table-column type="index" width="60" label="序号" />
                            <template v-for="column in importTableModel">
                                <el-table-column  v-if="column.show" :key="column.prop" :prop="column.prop" :label="column.label" :width="column.width" />
                            </template>
                    </el-table>
                </div>
                <div class="file-data-page">
                    <el-pagination
                        v-model:currentPage="params.page"
                        v-model:page-size="params.size"
                        :page-sizes="[20, 50, 100, 500]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="allData.length"
                        @size-change="sizeChange"
                        @current-change="pageChange"
                        >
                    </el-pagination>
                </div>
                <template #footer>
                    <div style="flex: auto" >
                        <el-button type="primary"  @click="sureUpload" style="margin-right: 20px"> 确定导入</el-button>
                        <el-button type="warning"  @click="toSelectFile" style="margin-right: 20px"> 重新上传</el-button>
                        <input type="file" style="display:none" @change="fileChange"
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
                        <el-button @click="innerPreviewDrawer=false">关闭</el-button>
                    </div>
                </template>
                </el-drawer>
           </div>

          <!-- 返回结果界面 -->
           <div>
               <el-drawer
                    v-model="innerResultDrawer"
                    :append-to-body="true"
                >
                <template #title>
                        <span class="import-title">{{title}}保存结果</span>
                </template>
                 <div class="file-select-view">
                    <el-descriptions
                        class="margin-top"
                        :column="1"
                        border
                        width="150px"
                    >
                        <el-descriptions-item label="成功：">
                           <span v-if="isSuccess">{{ allData.length-failureData.length}}</span> 
                           <span v-else>0</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="失败：">
                            <span v-if="isSuccess">
                                {{failureData.length}}
                                <el-button type="text" v-if="failureData.length>0" @click="innerPreviewFailDrawer=true" style="margin-left: 20px"> 预览</el-button>
                                <el-button type="text" v-if="failureData.length>0" @click="exportFailureData"  style="margin-left: 20px"> 导出</el-button>
                            </span>
                            <span v-else>{{allData.length}}</span>
                        </el-descriptions-item>
                        <el-descriptions-item v-if="!isSuccess" label="提示：">
                           <span style="color:red">{{failMsg}}</span> 
                        </el-descriptions-item>
                    </el-descriptions>
                </div>
                <template #footer>
                    <div style="flex: auto" >
                        <el-button @click="innerResultDrawer=false">关闭</el-button>
                    </div>
                </template>
                </el-drawer>
           </div>

            <!-- 预览上传失败数据页面 -->
           <div>
               <el-drawer
                    v-model="innerPreviewFailDrawer"
                    :append-to-body="true"
                    :size="previewWidth"
                >
                <template #title>
                        <span class="import-title">{{title}}-上传失败信息预览</span>
                </template>
                <div class="file-data-preview">
                    <el-table :data="failureTableData" border height="100%"  header-cell-class-name="hrsys-table-header"> 
                            <el-table-column type="index" width="60" label="序号" />
                            <el-table-column v-for="column in importTableModel"  :key="column.prop" :prop="column.prop" :label="column.label" :width="column.width" />
                    </el-table>
                </div>
                <div class="file-data-page">
                    <el-pagination
                        v-model:currentPage="failureParams.page"
                        v-model:page-size="failureParams.size"
                        :page-sizes="[20, 50, 100, 500]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="failureData.length"
                        @size-change="failureSizeChange"
                        @current-change="failurePageChange"
                        >
                    </el-pagination>
                </div>
                <template #footer>
                    <div style="flex: auto" >
                        <el-button type="primary" @click="exportFailureData"  style="margin-right: 20px"> 导出</el-button>
                        <el-button @click="innerPreviewFailDrawer=false">关闭</el-button>
                    </div>
                </template>
                </el-drawer>
           </div>
            
            <template #footer>
                <div style="flex: auto">
                    <el-button @click="fileImportDrawerBeforeClose">取消</el-button>
                </div>
            </template>
        </el-drawer>
</template>

<script>
import  * as XLSX from 'xlsx'
import { defineComponent } from 'vue'
import { ElLoading } from 'element-plus'
//import { excelImportModelPathname, generateUrl, getExcelImportModel } from '@/api/common'
export default defineComponent({
    emits: ['upload', 'update:modelValue'],
    data() {
        return {
            //下级抽屉显示状态
            innerPreviewDrawer:false,//导入预览
            innerResultDrawer:false,//返回结果
            innerPreviewFailDrawer:false,//失败数据预览

            allData: [],  // 解析出来的所有数据
            tableData: [],  // 预览的数据
            failureData: [], // 失败的所有数据
            failureTableData: [], // 失败显示的数据
            importData:[],//保存时导入的数据（字段筛选）
            file: null,
            params: {
                page: 1,
                size: 10
            },
            failureParams: {
                page: 1,
                size: 10
            },
            isSuccess:false,
            failMsg:"",
        }
    },
    props: {
        modelValue: Boolean,
        'title': { // 标题
            type: String,
            default: '导入数据'
        },
        'isTemplate': {  // 是否显示下载导入模板，默认为 true
            type: Boolean,
            default: true
        },
        //数据预览弹框宽度
        'previewWidth':{
            type: String,
            default: '30%'
        },
        //数据预览表格表头
        'importTableModel':Object,

        'upload': {  // 上传的 Promise
            type: Function,
            required: true
        },
        'uploadParams': Object,  // 上传参数
        'uploadSuccess': Function,  // 上传成功回调
        'uploadFailure': Function,  // 上传失败回调
        'parseData': Function, // 解析数据方法，返回数据
        'loadModels': Function, // 下载模板
        'importTips':String,//导入提示
        // 解析excel参数
        'parseOpts': Object 
    },
    computed: {
        isShowFileImportDrawer: {
            get() {
                return this.modelValue; 
            },
            set(value) {
                this.$emit('update:modelValue', value); 
            }
        },
       
       
        
    },
    methods: {
        toSelectFile(event) {
            event.currentTarget.nextElementSibling.click();
        },
        toPreview() {
            // this.tableData = this.allData.slice(0, 10);
            this.pageChange(1);
            this.innerPreviewDrawer=true;
        },
        pageChange(page) {
            this.params.page = page;
            let start = (page - 1) * this.params.size;
            this.tableData = this.allData.slice(start, start + this.params.size);
        },
        sizeChange(size) {
            this.params.size = size;
            this.pageChange(1);
        },
        failurePageChange(page) {
            this.failureParams.page = page;
            let start = (page - 1) * this.failureParams.size;
            this.failureTableData = this.failureData.slice(start, start + this.failureParams.size);
        },
        failureSizeChange(size) {
            this.failureParams.size = size;
            this.failurePageChange(1);
        },
        // 将对应的中文key转化为表格模板对应的英文key
        dataTransition(data){
            let importlist = [];
            let list = [];
            if(!data){
                return list;
            }
            data.forEach(row => {
                var obj = {};
                var importObj = {};
                for(var key in row) {
                    this.importTableModel.forEach(colum => {
                        if(key===colum.label){
                            obj[colum.label]=row[key];
                            //需要导入的字段
                            if(colum.isNoImport){
                                importObj[colum.label]=row[key];
                            }
                        }
                    });
                }
                list.push(obj);
                this.importData.push(importObj);
            });
            return list;
        },
        //下载导入模板
        getImportTemplate() {
           this.loadModels()
        },
        fileChange(event) {

            if (!event.currentTarget.files.length) {
                return
            }
            this.allData=[];  // 解析出来的所有数据
            this.tableData=[];  // 预览的数据
            this.failureData=[]; // 失败的所有数据
            this.failureTableData=[]; // 失败显示的数据
            this.importData=[];//保存时导入的数据（字段筛选）
            this.isSuccess=false;
            this.failMsg="";

            const that = this
            // 拿取文件对象
            var f = event.currentTarget.files[0];
            if (f == null) {
                this.$message.warning('您未选择任何文件');
                return;
            }
            if (f.type != 'application/vnd.ms-excel' && f.type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ) {
                this.$message.warning('请选择excel文件');
                return;
            }

            this.params.page = 1;
            this.allData = [];
            this.tableData = [];
            this.failureParams.page = 1;
            this.failureData = [];
            this.failureTableData = [];

            this.file = f;
            // 用FileReader来读取
            var reader = new FileReader()
            // 重写FileReader上的readAsBinaryString方法
            FileReader.prototype.readAsBinaryString = function (f) {
                var binary = ''
                var wb // 读取完成的数据
                var outdata // 你需要的数据
                var reader = new FileReader()
                reader.onload = function (e) {
                    // 读取成Uint8Array，再转换为Unicode编码（Unicode占两个字节）
                    var bytes = new Uint8Array(reader.result)
                    var length = bytes.byteLength
                    for (var i = 0; i < length; i++) {
                        binary += String.fromCharCode(bytes[i])
                    }
                    // 接下来就是xlsx了，具体可看api
                    wb = XLSX.read(binary, {
                        type: 'binary'
                    })

                    if (that.parseData) {
                        outdata = that.parseData(XLSX, wb);
                    } else {
                        let parseOpts = { defval: '', blankrows: true };
                        for (let key in that.parseOpts) {
                            parseOpts[key] = that.parseOpts[key];
                        }
                        //console.log('parseOpts: ', parseOpts);    
                        outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], parseOpts);
                    }
                    
                    // console.log('outdata = ' + JSON.stringify(outdata))
                    //console.log('outdata: ', outdata);
                    let list = [];
                    outdata.forEach(row => {
                        var obj = {};
                        var importObj = {};
                        for(var key in row) {
                            that.importTableModel.forEach(colum => {
                                if(key===colum.label){
                                    obj[colum.prop]=row[key];
                                    //需要导入的字段
                                    if(colum.isNoImport){
                                        importObj[colum.prop]=row[key];
                                    }
                                }
                            });
                        }
                        if(obj != {}){
                            list.push(obj);
                        }
                        if(importObj != {}){
                             that.importData.push(importObj);
                        }
                    });
                    that.allData = list;
                    // 自定义方法向父组件传递数据
                    // that.$emit('getResult', outdata);
                    that.toPreview();
                }
                reader.readAsArrayBuffer(f);
            }
            reader.readAsBinaryString(f);
            // this.toPreview();
            
        },
        exportFailureData() {
            let failData =this.failureData;
            let importData = [];
            let i=1;
            failData.forEach(row => {
                var obj = {};
                obj["序号"]=i;
                for(var key in row) {
                    this.importTableModel.forEach(colum => {
                        if(key===colum.prop){
                            obj[colum.label]=row[key];
                        }
                    });
                }
                if(obj != {}){
                    i++;
                    importData.push(obj);
                }
            });
            var filename = "导入失败.xlsx"; //文件名称
            // var data = [[1,2,3],[true, false, null, "sheetjs"],["foo","bar",new Date("2014-02-19T14:30Z"), "0.3"], ["baz", null, "qux"]];  //数据，一定注意需要时二维数组
            var ws_name = "Sheet1"; //Excel第一个sheet的名称
            var wb = XLSX.utils.book_new(),
                ws = XLSX.utils.json_to_sheet(importData);
            XLSX.utils.book_append_sheet(wb, ws, ws_name);  //将数据添加到工作薄
            XLSX.writeFile(wb, filename);

        },
        sureUpload() {
            const loading = this.openFullScreen();
            if (!this.upload) {
                return;
            }
            this.upload(this.importData, this.uploadParams).then(res => {
                this.isSuccess=res.data.status;
                this.failMsg=res.data.msg;
                if (res.data.status) {
                    this.showErrorInfo(res.data.data);
                    this.uploadSuccess && this.uploadSuccess(res.data);
                } else {
                    this.$alert(res.data.msg, '提示')
                    this.showErrorInfo(res.data.data);
                    this.uploadFailure && this.uploadFailure(res.data);
                }
                loading.close()
                this.innerResultDrawer=true;//打开返回结果
                this.innerPreviewDrawer=false;//关闭导入预览
            }).catch(err => {
                loading.close()
                console.error(err)
                this.$alert('系统异常，请稍后重试');
                this.uploadFailure && this.uploadFailure();
            });
        },
        showErrorInfo(data) {
            if (!data || data.length == 0) {
                this.failureData = [];
            } else {
                this.failureData =data;
                this.failureTableData = this.failureData.slice(0, 0 + this.failureParams.size);
            }
            this.failurePageChange(1);
        },
        //关闭前回调=第一个抽屉
        fileImportDrawerBeforeClose(){
            this.allData=[];  // 解析出来的所有数据
            this.tableData=[];  // 预览的数据
            this.failureData=[]; // 失败的所有数据
            this.failureTableData=[]; // 失败显示的数据
            this.importData=[];//保存时导入的数据（字段筛选）
            this.isSuccess=false;
            this.failMsg="";
            this.file=null;
            this.isShowFileImportDrawer=false;
        },
        //打开全屏加载动效
        openFullScreen(){
            const loading = ElLoading.service({
                lock: true,
                text: '数据导入中... 请等待！',
                background: 'rgba(0, 0, 0, 0.7)',
            })
            return loading;
        },
         
    }
})
</script>

<style lang="scss" scoped>
.import-title {
    font-weight: bold;
    color: #2483C6;
    font-size: 1.5em;
}
.file-select-view{
    padding: 0px 10px;
}
.file-up-tips{
    .tips-cen{
        padding: 5px 10px;
        text-align: left;
        width: 233px;
        line-height: 23px;
        font-weight: 500;
        border: solid 1px black;
        border-radius: 5px;
        background-color: #fff8eb;
    }
}
.file-data-preview{
    height: calc(100% - 50px);
}
.file-data-page{
    padding-top: 10px;
}
</style>
<style lang="scss">
    .file-select-view{
        .el-descriptions__label {
            width: 120px;
        }
    }
</style>
